import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import Image from "../../lib/Image";
import { useHistory } from "react-router-dom";
import general from "../../general";
import { Link } from "react-router-dom";

export default ({ query, setTitle }) => {
  const history = useHistory();
  const [swiper, setSwiper] = useState();
  const [imgs, setImgs] = useState([]);
  const [img, setImg] = useState(0);
  const [imgIndex, setImgIndex] = useState(0);

  const [tradeId, setTradeId] = useState(null);

  useEffect(() => {
    setImgs(query.imgs?.split(",") || general.imgs);
    setImg(parseInt(query.img));
    setTradeId(query.tradeId);
  }, [query]);
  useEffect(() => {
    swiper && swiper.slideTo(img);
  }, [img]);

  useEffect(() => {
    setTitle(
      <div>
        {imgIndex + 1}/{imgs.length}
      </div>
    );
  }, [imgIndex, imgs]);

  return (
    <>
      <div
        className="view-img"
        onClick={() => history.goBack()}
        style={{
          paddingBottom: tradeId
            ? "calc(env(safe-area-inset-bottom) + 1.54rem)"
            : "calc(env(safe-area-inset-bottom))",
        }}
      >
        <Swiper
          initialSlide={0}
          pagination={{ clickable: true }}
          onSwiper={setSwiper}
          onSlideChange={(swiper) => setImgIndex(swiper.activeIndex)}
        >
          {imgs?.map((img, index) => (
            <SwiperSlide key={index} className="img">
              <Image src={img} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {tradeId && (
        <Link to={"/trade/detail?id=" + tradeId} className="view-trade-detail">
          查看账号详情
        </Link>
      )}
    </>
  );
};
